import { AddressTypes, ECategoryOfWarehouse } from '@models';
import { AddressSettings } from '@shared';

export function checkPackingServiceDisabled(AddressSender, AddressRecipient, toggleFn: () => void): boolean {
  if (!AddressSender?.value || !AddressRecipient?.value) {
    return false;
  }

  const senderAddress = AddressSender.value;
  const recipientAddress = AddressRecipient.value;
  const sentFromDoors = senderAddress.type === AddressTypes.DOORS;
  const receivedByDoors = recipientAddress.type === AddressTypes.DOORS;
  const receivedByIndexAddressPostbox = recipientAddress.type === AddressTypes.INDEX && recipientAddress.data?.warehouse?.TypeOfWarehouse === AddressSettings.POSTBOX_TYPE;
  const noSendingWarehouseSelected = !senderAddress.data?.warehouse && !senderAddress.data?.Ref;
  const noReceivingWarehouseSelected = !recipientAddress.data?.warehouse && !recipientAddress.data?.Ref;
  const recipientCategoryOfWarehouseAllowedTypes = [
    ECategoryOfWarehouse.Branch,
    ECategoryOfWarehouse.Store,
    ECategoryOfWarehouse.DropOff,
  ];
  const receivedByAllowedCategoryOfWarehouseNewAddress = recipientCategoryOfWarehouseAllowedTypes.some(type => recipientAddress.data?.warehouse?.CategoryOfWarehouse === type);
  const receivedByAllowedCategoryOfWarehouseSavedAddress = recipientCategoryOfWarehouseAllowedTypes.some(type => recipientAddress.data?.CategoryOfWarehouse === type);
  const receivedByBranch = receivedByAllowedCategoryOfWarehouseNewAddress || receivedByAllowedCategoryOfWarehouseSavedAddress;

  const condition = sentFromDoors
    || receivedByDoors
    || receivedByIndexAddressPostbox
    || noReceivingWarehouseSelected
    || noSendingWarehouseSelected
    || !receivedByBranch;

  if (condition) {
    toggleFn();
  }

  return condition;
}
